import { ProjectActions } from '@octopus-do/octopus-project-core'

import { initialTags } from './initialTags'

export const InitTagsAction = ProjectActions.tags.add({
  items: initialTags,
})
